const state = {
    isDriving: false,
    currentTaskId: Number(localStorage.getItem("currentTaskId")) || null,
    currentTimerId: Number(localStorage.getItem("currentTimerId")) || null,
    currentPhase: localStorage.getItem("currentPhase") || "idle",
};
const mutations = {
    setCurrentTaskId(state, id) {
        state.currentTaskId = id;
        localStorage.setItem("currentTaskId", id?.toString() || "");
    },
    setCurrentTimerId(state, id) {
        state.currentTimerId = id;
        localStorage.setItem("currentTimerId", id?.toString() || "");
    },
    setPhase(state, phase) {
        state.currentPhase = phase;
        localStorage.setItem("currentPhase", phase);
    },
};
const actions = {
    async startDriveTo({ commit, dispatch }, taskId) {
        if (!taskId) {
            throw new Error("Kein Task ausgewählt");
        }
        const timer = await dispatch('worktime/startTimer', {
            taskId: taskId,
            type: 'drive_to'
        }, { root: true });
        commit("setCurrentTaskId", taskId);
        commit("setCurrentTimerId", timer.id);
        commit("setPhase", "drive_to");
    },
    async stopDriveTo({ commit, state, dispatch }) {
        if (!state.currentTimerId)
            return;
        await dispatch("worktime/stopTimer", state.currentTimerId, { root: true });
        commit("setCurrentTimerId", null);
        commit("setPhase", "after_drive_to");
    },
    async startWork({ commit, state, dispatch }) {
        const timer = await dispatch("worktime/startTimer", {
            taskId: state.currentTaskId,
            type: "work",
        }, { root: true });
        commit("setCurrentTimerId", timer.id);
        commit("setPhase", "work");
    },
    async startPause({ commit, state, dispatch }) {
        await dispatch("worktime/stopTimer", state.currentTimerId, { root: true });
        commit("setCurrentTimerId", null);
        commit("setPhase", "pause");
    },
    async stopWork({ commit, state, dispatch }) {
        if (!state.currentTimerId)
            return;
        await dispatch("worktime/stopTimer", state.currentTimerId, { root: true });
        commit("setCurrentTimerId", null);
        commit("setPhase", "after_work");
    },
    async startDriveHome({ commit, state, dispatch }) {
        const timer = await dispatch("worktime/startTimer", {
            taskId: state.currentTaskId,
            type: "drive_home",
        }, { root: true });
        commit("setCurrentTimerId", timer.id);
        commit("setPhase", "drive_home");
    },
    async stopDriveHome({ commit, state, dispatch }) {
        if (!state.currentTimerId)
            return;
        await dispatch("worktime/stopTimer", state.currentTimerId, { root: true });
        commit("setCurrentTimerId", null);
        commit("setCurrentTaskId", null);
        commit("setPhase", "idle");
    },
};
const getters = {
    isDriving: state => state.isDriving,
    currentPhase: state => state.currentPhase,
    currentTaskId: state => state.currentTaskId,
};
export const Drives = {
    namespaced: true,
    state,
    mutations,
    actions,
    getters,
};
